/* src/app/components/toast/toast.component.scss */
:host ::ng-deep .toast-body {
  padding: 1rem 1.5rem 0.5rem 0.5rem;
  position: relative;
  overflow: hidden;
}
@keyframes toast-shrink {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}
.toast {
  position: fixed;
  bottom: 2rem;
  max-width: 18rem;
  width: 100%;
  left: 1rem;
  z-index: 9999;
  border: 0.0625rem solid #155cb4;
  background-color: #ffffff;
  border-radius: 0.125rem;
}
.toast .ic-font {
  font-size: 1.5rem;
  color: #155cb4;
}
.toast .toast-progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 3px;
  width: 100%;
  background-color: #155cb4;
  animation: toast-shrink linear forwards;
}
.toast-success {
  border-color: #168736;
}
.toast-success .ic-font {
  color: #168736;
}
.toast-success .toast-progress-bar {
  background-color: #168736;
}
.toast-warning {
  border-color: #ff9831;
}
.toast-warning .ic-font {
  color: #ff9831;
}
.toast-warning .toast-progress-bar {
  background-color: #ff9831;
}
.toast-error {
  border-color: #89251c;
}
.toast-error .ic-font {
  color: #89251c;
}
.toast-error .toast-progress-bar {
  background-color: #89251c;
}
.toast .toast-header {
  padding: 0;
  border-bottom: 0;
}
.toast .toast-header .toast-title {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #2e2e38;
  margin-left: 0.5rem;
}
.toast .toast-description {
  padding-left: 2rem;
  display: block;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 300;
  color: rgba(46, 46, 56, 0.64);
}
.toast .toast-footer {
  display: flex;
  justify-content: flex-end;
}
.toast .toast-footer .btn-clear {
  margin-right: -0.5rem;
}
/*# sourceMappingURL=toast.component.css.map */
